import { useEffect } from 'preact/compat'
import { useDispatch, useSelector } from 'react-redux'
import { DataDog } from '../datadog/index'
import { transactionDetailsUpdate } from '../redux/slice/transactionDetailsSlice'

export default function useAmount(amount) {
  const dispatch = useDispatch()
  const transactionDetails = useSelector(state => state.transactionDetails)

  useEffect(() => {
    if (amount === undefined || !transactionDetails?.maxAmount) return

    const overrideAmount = Number(amount)
    if (
      Number.isInteger(overrideAmount) &&
      !Number.isNaN(overrideAmount) &&
      overrideAmount >= transactionDetails.minAmount &&
      overrideAmount <= transactionDetails.maxAmount
    ) {
      dispatch(transactionDetailsUpdate({ overrideAmount }))
      DataDog.info('MFE "amount" attribute has been changed', overrideAmount)
    } else {
      dispatch(transactionDetailsUpdate({ overrideAmount: null }))
      console.error("[MFE Payments]: Attribute 'amount' has incorrect value")
      DataDog.info(
        'MFE "amount" attribute has been changed with incorrect value',
        overrideAmount,
      )
    }
  }, [amount, transactionDetails.maxAmount])
}
